export const DESKTOP_TEXT_WIDTH = 350;

export const POST_TEXT_SCROLL_OFFET = 5;
